export const visit = (vm, at) => {
vm(require("routing-ui/lang/en.lyaml"));
vm(require("./routing-rules/en.lyaml"));
at({ "en": { "routing": { "channelNames": { "liveChat": "Live Chat", "facebookMessenger": "Facebook Messenger", "email": "Email", "forms": "Forms", "customerPortal": "Customer Portal", "comments": "Comments", "feedback": "Feedback", "whatsapp": "WhatsApp", "call": "Call", "sms": "SMS", "unknown": "Unknown" } } } });
};